import { Box, Heading, Text } from "@chakra-ui/react";
import Card from "components/card";

const NotFound = () => {
    return (
        <div className="mt-8 md:mt-4">
            <Card>
                <Box textAlign="center" py={10} px={6}>
                    <Heading display="inline-block" as="h2" size="4xl" bgGradient="linear(to-r, gray.400, gray.600)" backgroundClip="text">
                        404
                    </Heading>
                    <Text fontSize="24px" mt={3} mb={2} className="!text-gray-500 dark:!text-gray-400">
                        Página no encontrada o en construcción
                    </Text>
                </Box>
            </Card>
        </div >

    );
};

export default NotFound;
